
 <div class="wrap_float">
    <h6 class="h2 problem-component-title" style="margin-top: 20px;"  i18n="@@comments">{{title?title:'Yorumlar'}}</h6>
    <div class="comments-form">
        <form [formGroup]="commentForm" (ngSubmit)="onSubmitComment()" novalidate>
                <textarea class="comment-text-area" formControlName="commentText" id="comment_id" i18n-placeholder="@@commentPlaceholder" placeholder="Yorum yazın..."
                    [ngClass]="{ 'is-invalid': submittedComment && commentForm.controls['commentText'].errors?.required }">
                </textarea>
                <div *ngIf="submittedComment && commentForm.controls['commentText'].errors?.required" class="invalid-feedback" style="display: grid">
                    <div  i18n="@@mustComment">Uygun bir yazı yazmanız gerekmektedir</div>
                </div>
            <button class="btn btn-warning mb-3 mt-2 comments-button"  i18n="@@postComment">Gönder</button>
        </form>
    </div>
<div class="comments-list">
    <div class="comments-list-item" *ngFor="let comment of comments; trackBy: trackByFnComment">
        <div class="comment-text p-3" (click)="openPopupWrapper(templateShowComment,comment);$event.preventDefault()" >
            <div class="comments-div">{{comment.createDate | date:'MM.dd.yyyy h:mm:ss' }}</div><br/>
            <p style="display: block;float: left;font-size: 14px;line-height: 22px;margin-top: 5px;width: 100%;text-align: left;">
                {{comment.text}}
            </p>
            <div class="comments-div" >
                 <button class="background:none;"(click)="openPopupNewComment($event,templateAddNewComment,comment);$event.preventDefault()" class="background-none" i18n-title="Cevapla" title="Cevapla">
                     <fa-icon [icon]="faCmnt"></fa-icon>
                     <em class="fas fa-comment" aria-hidden="true" style="font-size: 16px"></em>
                     <span  style="margin-left: 5px;">{{comment?.commentCount}}</span>
                    </button>
                <button class="background-none" (click)="updateUserLike($event,comment,1)" style="margin-left: 20px;" i18n-title="Beğen" title="Beğen">
                 <fa-icon [icon]="faThmbsU"></fa-icon>
                    <em class="fas fa-thumbs-up" style="font-size: 16px;" [ngStyle]="{'color': comment?.commentlike?.like==1 ? 'green' : ''}"></em>
                    <span class="like-no">{{comment.likeOn}}</span>
                </button>
                <button class="background-none" (click)="updateUserLike($event,comment,-1)" i18n-title="Beğenme" title="Beğenme" style="margin-left: 5px;">
                    <fa-icon [icon]="faThmbsD"></fa-icon>
                    <em class="fas fa-thumbs-down" style="border:none; font-size: 16px;" [ngStyle]="{'color':  comment?.commentlike?.like==-1 ? 'red' : ''}"></em>
                    <span class="like-no">{{comment.likeOff}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
</div>

<div class="show-more"(click)="onNextComment()" *ngIf="commentCount>comments.length" >
    <div class="show-more-sub">
        <span i18n="@@showmore">Daha Fazla</span>
    </div>
</div>

<ng-template #templateAddNewComment let-modal>
    <div class="modal-dialog modal-dialog-scrollable" style="max-width: 100%!important; margin: 0px;padding-left: 10px;">
        <div class="modal-content">
            <div class="modal-header">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
			</div>
            <div class="modal-body">
                <div class="comments-div"> {{selectedComment.createDate | date:'MM.dd.yyyy h:mm:ss' }}</div><br/>
                <p style="display: block;float: left;font-size: 14px;line-height: 22px;margin-top: 5px;">
                    {{selectedComment.text}}
                </p>
                <br>
                <br>
                <div class="comments-list-item" *ngFor="let comment of commentIns; trackBy: trackByFnComment">
                    <div style="cursor: pointer; padding: 38px 35px 38px 86px;position: relative;display: block;float: left;width: 100%;margin-bottom: 20px;background: #ebebeb;border-radius: 8px;color: black;">
                        <div class="comments-div">{{comment.createDate | date:'MM.dd.yyyy h:mm:ss' }}</div><br/>
                        <p style="display: block;float: left;font-size: 14px;line-height: 22px;margin-top: 5px;">
                            {{comment.text}}
                        </p>
                    </div>
                </div>
                <form [formGroup]="commentCommentForm" (ngSubmit)="onSubmitCommentComment()" novalidate>
                    <div class="input-wrap textarea-wrap white-label comment-field">
                        <textarea style="padding-top:20px;width: 100%; height: 100px; border-radius: 8px;display: block;  float: left; padding: 25px 25px; font-size: 16px; font-weight: 400; border:1px solid #8E8E8E;background-color: #ebebeb;" formControlName="commentText" id="comment_id" class="input textarea" i18n-placeholder="@@commentPlaceholder" placeholder="Yorum yazın..."
                            [ngClass]="{ 'is-invalid': submittedCommentComment && commentCommentForm.controls['commentText'].errors?.required }">
                        </textarea>
                        <div *ngIf="submittedCommentComment && commentCommentForm.controls['commentText'].errors?.required" class="invalid-feedback" style="display: grid">
                            <div  i18n="@@mustComment">Uygun bir yazı yazmanız gerekmektedir</div>
                        </div>
                    </div>
                    <button class="btn btn-warning btn-bottom" style="margin-top: 20px;" i18n="@@postComment">Gönder</button>
                </form>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #templateShowComment let-modal>
    <div class="modal-dialog modal-dialog-scrollable" style="max-width: 100%!important; margin: 0px;">
        <div class="modal-content">
            <div class="modal-header">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
			</div>
            <div class="modal-body">
                <div class="comments-div">{{selectedComment.createDate | date:'MM.dd.yyyy h:mm:ss' }}</div><br/>
                <p style="display: block;float: left;font-size: 14px;line-height: 22px;margin-top: 5px;">
                    {{selectedComment.text}}
                </p>
                <br>
                <br>
                <div class="comments-list-item" *ngFor="let comment of commentIns; trackBy: trackByFnComment">
                    <div style="cursor: pointer; padding: 38px 35px 38px 86px;position: relative;display: block;float: left;width: 100%;margin-bottom: 20px;background: #ebebeb;border-radius: 8px;color: black;">
                        <div class="comments-div">{{comment.createDate | date:'MM.dd.yyyy h:mm:ss' }}</div><br/>
                        <p style="display: block;float: left;font-size: 14px;line-height: 22px;margin-top: 5px;">
                            {{comment.text}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
